import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'supply-by-demand-component',
  templateUrl: './supply-by-demand.component.html',
  styleUrls: ['./supply-by-demand.component.scss'],
})
export class SupplyByDemandComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
